@if (enterWeightForm) {
  <form class="follow-up" [formGroup]="enterWeightForm" (submit)="onSubmitConsultation($event)">
    <div class="follow-up-fields">
      <div class="follow-up-fields-wrapper">
        <div class="follow-up-field follow-up-field--visit-date">
          @let dateError = dateErrorMessage();
          <div class="datepicker-wrapper">
            <label class="datepicker-label">
              <span>{{ 'follow-up_form-label-date' | translateKey }}</span>
            </label>
            <div class="datepicker" [class.error-state]="dateError">
              <input
                formControlName="visitDate"
                [formControl]="$any(enterWeightForm.get('visitDate'))"
                autocomplete="off"
                matInput
                [min]="this.lastConsultation?.visit.visitDateTime"
                [matDatepicker]="picker"
                id="visitDate"
                class="error-input datepicker-input"
                placeholder="{{ 'follow-up_form-label-date' | translateKey }}"
              />
              <app-icon
                [class.error]="dateError"
                [name]="IconName.calendar_small"
                class="datepicker-icon"
                (click)="picker.opened ? picker.close() : picker.open()"
              ></app-icon>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            @if (dateError) {
              <span class="datepicker-error">{{ dateError }}</span>
            }
          </div>
        </div>
        <div class="follow-up-field follow-up-field--weight">
          <rc-field
            id="weight"
            formControlName="weight"
            type="number"
            [forceTypeNumber]="true"
            [error]="WeightErrorMessage()"
            autocomplete="off"
            [label]="'form-attribute_pet-weight' | translateKey"
          >
            <ng-container suffix>
              <span class="kilo-label"> {{ weightSuffix$ | async }} </span>
            </ng-container>
          </rc-field>
        </div>
      </div>
      <div class="clear"></div>
      <div class="follow-up-field--information">
        <div class="rc-icon rc-icon--alert follow-up-field--information_icon"></div>
        <span class="follow-up-field--information_label">
          <ng-container i18n="@@follow-up_info-label">Weight should be between</ng-container>
          @if (!isLoading) {
            <span class="kilo-label"> {{ minWeight }} </span>
          }
          <span [class.loading]="isLoading"></span>
          <span class="kilo-label"> {{ weightSuffix$ | async }} </span>
          <ng-container i18n="@@and">and</ng-container>
          @if (!isLoading) {
            <span class="kilo-label"> {{ maxWeight }} </span>
          }
          <span [class.loading]="isLoading"></span>
          <span class="kilo-label"> {{ weightSuffix$ | async }} </span>
        </span>
      </div>
    </div>
    <div class="follow-up-footer">
      <rc-button
        id="saveFollowUpChanges"
        data-qa="vs-weight-management-follow-up-button-save-changes"
        [disabled]="enterWeightForm.invalid"
        type="submit"
        (click)="onSubmitConsultation($event)"
      >
        {{ 'action_save-changes' | translateKey }}
      </rc-button>
    </div>
  </form>
}
